import { FC, ReactNode } from 'react';
import { createBemBlockBuilder } from '@ebsco-ui/ebsco-ui';

import { RedirectToLoginButton } from '@app/components';

interface GuestUserModalStateProps {
  message: ReactNode;
  redirectBackRoute?: string;
}

const cnBem = createBemBlockBuilder(['modal']);

export const GuestUserModalState: FC<GuestUserModalStateProps> = ({
  message,
  redirectBackRoute,
}) => (
  <div className={cnBem('__signInMessage')}>
    <div>{message}</div>
    <RedirectToLoginButton redirectBackRoute={redirectBackRoute} />
  </div>
);
